aracwebshop.ProductSearch = class {
	constructor(opts) {
		/* Options: search_box_id (for custom search box) */
		$.extend(this, opts);
		this.MAX_RECENT_SEARCHES = 4;
		this.search_box_id = this.search_box_id || "#search-box, #search-box-mobile";
		this.search_request_id = 0;
		this.is_search_dropdown_interaction = false;
		this.search_dropdown_interaction_timer = null;

		this.setupSearchDropDown();
		this.bindSearchAction();
	}

	setupSearchDropDown() {
		this.search_area = $("#dropdownMenuSearch").length ? $("#dropdownMenuSearch") : $("#dropdownMenuSearchMobile");
		if (!this.search_area.length) {
			this.search_area = $("body");
		}
		this.setupSearchResultContainer();
		this.populateRecentSearches();
	}

	isMobileSearchViewport() {
		if (window.matchMedia) {
			return window.matchMedia("(max-width: 767px)").matches;
		}
		return window.innerWidth < 768;
	}

	mountSearchDropdown($container) {
		if (!this.search_dropdown || !this.search_dropdown.length) {
			return;
		}

		let dropdown = this.search_dropdown[0];
		if (this.isMobileSearchViewport()) {
			// Safari treats fixed descendants of a backdrop-filter element as if they
			// were positioned from that element. Keep the mobile popup at the body
			// level so its viewport coordinates are identical in both themes.
			if (document.body && dropdown.parentNode !== document.body) {
				document.body.appendChild(dropdown);
			}
			return;
		}

		if ($container.length && !$.contains($container[0], dropdown)) {
			$container.append(this.search_dropdown);
		}
	}

	positionSearchDropdown($input) {
		if (!this.search_dropdown || !this.search_dropdown.length) {
			return;
		}

		let dropdown_style = this.search_dropdown[0].style;
		if (!this.isMobileSearchViewport() || !$input || !$input.length) {
			dropdown_style.removeProperty("--arac-search-results-top");
			dropdown_style.removeProperty("--arac-search-results-max-height");
			return;
		}

		let $anchor = $input.closest("#dropdownMenuSearchMobile");
		let anchor = ($anchor.length && $anchor[0]) || $input[0];
		if (!anchor || typeof anchor.getBoundingClientRect !== "function") {
			return;
		}

		let anchor_rect = anchor.getBoundingClientRect();
		let viewport = window.visualViewport;
		let viewport_top = viewport ? viewport.offsetTop : 0;
		let viewport_height = viewport ? viewport.height : window.innerHeight;
		let dropdown_top = Math.max(viewport_top + 8, anchor_rect.bottom + 8);
		let available_height = Math.max(0, viewport_top + viewport_height - dropdown_top - 16);

		dropdown_style.setProperty("--arac-search-results-top", `${Math.round(dropdown_top)}px`);
		dropdown_style.setProperty("--arac-search-results-max-height", `${Math.floor(available_height)}px`);
	}

	repositionOpenSearchDropdown() {
		if (!this.search_dropdown || this.search_dropdown.hasClass("hidden")) {
			return false;
		}

		let $focused_input = $(this.search_box_id).filter(":focus").first();
		if (!this.isMobileSearchViewport() || !$focused_input.length) {
			return false;
		}

		this.positionSearchDropdown($focused_input);
		return true;
	}

	bindSearchAction() {
		let me = this;

		// Attach listeners to all matching search inputs and toggle clear X button
		$(document)
			.off("focus.arac_product_search input.arac_product_search", this.search_box_id)
			.on("focus.arac_product_search input.arac_product_search", this.search_box_id, function(e) {
			let $input = $(this);
			let $container = $input.closest("#dropdownMenuSearch, #dropdownMenuSearchMobile");
			let $clearBtn = $container.find(".search-clear-btn");

			if ($input.val().length > 0) {
				$clearBtn.removeClass("hidden");
			} else {
				$clearBtn.addClass("hidden");
			}

			me.mountSearchDropdown($container);
			me.positionSearchDropdown($input);

			let query = $input.val();

			if (query.length == 0) {
				me.search_request_id += 1;
				me.populateResults(null);
				me.populateCategoriesList(null);
			}

			if (query.length < 3 || !query.length) {
				me.search_dropdown.removeClass("hidden");
				return;
			}

			let request_id = ++me.search_request_id;
			frappe.call({
				method: "aracwebshop.templates.pages.product_search.search",
				args: {
					query: query
				},
				callback: (data) => {
					let current_query = ($input.val() || "").toString();
					if (request_id !== me.search_request_id || current_query !== query) {
						return;
					}

					let product_results = null, category_results = null, category_groups = null;

					// Populate product results
					product_results = data.message ? data.message.product_results : null;
					me.populateResults(product_results);

					// Populate categories
					if (me.category_container) {
						category_results = data.message ? data.message.category_results : null;
						category_groups = data.message ? data.message.category_groups : null;
						let has_category_groups = Array.isArray(category_groups) && category_groups.length;
						me.populateCategoriesList(has_category_groups ? category_groups : category_results);
					}

					// Populate recent search chips only on successful queries
					if (
						!$.isEmptyObject(product_results)
						|| !$.isEmptyObject(category_results)
						|| !$.isEmptyObject(category_groups)
					) {
						me.setRecentSearches(query);
					}
				}
			});

			me.search_dropdown.removeClass("hidden");
		});

		// Handle Enter key on search inputs -> global storefront search results.
		$(document)
			.off("keydown.arac_product_search keypress.arac_product_search", this.search_box_id)
			.on("keydown.arac_product_search", this.search_box_id, (e) => {
			if (e.key === "Enter" || e.keyCode === 13 || e.which === 13) {
				e.preventDefault();
				const q = ($(e.target).val() || "").trim();
				me.search_dropdown.addClass("hidden");
				$(e.target).blur();

				if (q) {
					me.setRecentSearches(q);
					me.goToSearchResults(q);
					return;
				}

				if (window.location.pathname === "/all-products" && window.aracwebshop && aracwebshop.product_view) {
					let route_params = frappe.utils.get_query_params();
					delete route_params.search;
					delete route_params.search_term;
					route_params.start = 0;
					const query_string = aracwebshop.product_view.get_query_string(route_params);
					window.history.pushState('search', '', `${location.pathname}?` + query_string);
					aracwebshop.product_view.get_item_filter_data(true);
				}
			}
		});

		// Clear search button (X) click action
		$(document)
			.off("click.arac_product_search", ".search-clear-btn")
			.on("click.arac_product_search", ".search-clear-btn", function(e) {
			e.preventDefault();
			e.stopPropagation();
			let $container = $(this).closest("#dropdownMenuSearch, #dropdownMenuSearchMobile");
			let $input = $container.find("input[type='search']");

			$input.val("").blur();
			$(this).addClass("hidden");
			me.search_dropdown.addClass("hidden");
			me.search_request_id += 1;

			if (window.aracwebshop && aracwebshop.product_view) {
				let route_params = frappe.utils.get_query_params();
				delete route_params.search;
				delete route_params.search_term;
				route_params.start = 0;
				const query_string = aracwebshop.product_view.get_query_string(route_params);
				window.history.pushState('search', '', `${location.pathname}?` + query_string);
				aracwebshop.product_view.get_item_filter_data(true);
			}
		});

		$(window).off("resize.arac_product_search").on("resize.arac_product_search", () => {
			if (me.search_dropdown && !me.search_dropdown.hasClass("hidden")) {
				window.requestAnimationFrame(() => {
					if (!me.repositionOpenSearchDropdown()) {
						me.search_dropdown.addClass("hidden");
					}
				});
			}
		});

		if (window.visualViewport) {
			$(window.visualViewport)
				.off("resize.arac_product_search scroll.arac_product_search")
				.on("resize.arac_product_search scroll.arac_product_search", () => {
					window.requestAnimationFrame(() => me.repositionOpenSearchDropdown());
				});
		}

		// Hide dropdown on page scroll, but keep it open while the user scrolls inside it.
		$(window).off("scroll.arac_product_search").on("scroll.arac_product_search", () => {
			if (
				me.search_dropdown
				&& !me.search_dropdown.hasClass("hidden")
				&& !me.is_search_dropdown_interaction
			) {
				if (!me.repositionOpenSearchDropdown()) {
					me.search_dropdown.addClass("hidden");
				}
			}
		});

		// Hide dropdown on click or touch outside
		$(document).off("click.arac_product_search_outside touchstart.arac_product_search_outside")
			.on("click.arac_product_search_outside touchstart.arac_product_search_outside", (e) => {
			let $target = $(e.target);
			let searchEvent = $target.closest(me.search_box_id).length || $target.closest(".search-clear-btn").length;
			let resultsEvent = $target.closest("#search-results-container").length;
			let isResultHidden = me.search_dropdown.hasClass("hidden");

			if (!searchEvent && !resultsEvent && !isResultHidden) {
				me.search_dropdown.addClass("hidden");
			}
		});
	}

	setupSearchResultContainer() {
		if ($("#search-results-container").length) {
			this.search_dropdown = $("#search-results-container");
			this.bindSearchDropdownScrollGuard();
			return;
		}

		this.search_dropdown = this.search_area.append(`
				<div class="arac-search-results-surface overflow-hidden shadow-2xl bg-white border border-slate-100 rounded-2xl w-full hidden absolute left-0 right-0 top-full mt-2 z-[10060] p-3 text-left"
				id="search-results-container"
				aria-labelledby="dropdownMenuSearch"
				style="display: flex; flex-direction: column;">
			</div>
		`).find("#search-results-container");
		this.bindSearchDropdownScrollGuard();

		this.setupCategoryContainer();
		this.setupProductsContainer();
		this.setupRecentsContainer();
	}

	markSearchDropdownInteraction() {
		this.is_search_dropdown_interaction = true;
		clearTimeout(this.search_dropdown_interaction_timer);
		this.search_dropdown_interaction_timer = setTimeout(() => {
			this.is_search_dropdown_interaction = false;
		}, 450);
	}

	bindSearchDropdownScrollGuard() {
		if (!this.search_dropdown || this.search_dropdown.data("scroll-guard-bound")) {
			return;
		}

		this.search_dropdown.data("scroll-guard-bound", true);
		this.search_dropdown.on(
			"pointerdown pointermove pointerup pointercancel touchstart touchmove touchend touchcancel wheel scroll",
			() => this.markSearchDropdownInteraction()
		);
	}

	setupProductsContainer() {
		this.products_section = $(`
			<div id="product-results" class="mt-2 hidden">
				<div id="product-scroll" class="flex flex-col gap-1 overflow-y-auto max-h-[300px]">
				</div>
			</div>
		`);
		this.search_dropdown.append(this.products_section);
		this.products_container = this.products_section.find("#product-scroll");
	}

	setupCategoryContainer() {
		this.category_section = $(`
			<div class="search-categories-container mt-1 mb-2 hidden">
				<div class="search-categories-panel">
				</div>
			</div>
		`);
		this.search_dropdown.append(this.category_section);
		this.category_container = this.category_section.find(".search-categories-panel");
	}

	setupRecentsContainer() {
		this.recents_section = $(`
			<div class="mb-2 recent-searches arac-search-recents-only border-t border-slate-100 pt-2">
				<div class="arac-search-section-label text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1">
					${ __("Recent") }
				</div>
			</div>
		`);
		this.search_dropdown.append(this.recents_section);

		this.recents_container = this.recents_section.append(`
			<div id="recents" class="flex flex-wrap gap-1.5 pt-1">
			</div>
		`).find("#recents");
	}

	updateSectionLayout() {
		if (!this.recents_section) return;
		const has_categories = this.category_section && !this.category_section.hasClass("hidden");
		const has_products = this.products_section && !this.products_section.hasClass("hidden");
		this.recents_section.toggleClass("arac-search-recents-only", !has_categories && !has_products);
	}

	getRecentSearches() {
		return JSON.parse(localStorage.getItem("recent_searches") || "[]");
	}

	attachEventListenersToChips() {
		let me = this;
		const chips = $(".recent-search");

		chips.off("click.arac_product_search_recent").on("click.arac_product_search_recent", function() {
			const text = $(this).text().trim();
			const activeInput = $(me.search_box_id).filter(":visible").first();
			if (activeInput.length) {
				activeInput.val(text).trigger("input").focus();
			}
		});
	}

	setRecentSearches(query) {
		let recents = this.getRecentSearches();
		if (recents.length >= this.MAX_RECENT_SEARCHES) {
			recents.splice(0, 1);
		}

		if (recents.indexOf(query) >= 0) {
			return;
		}

		recents.push(query);
		localStorage.setItem("recent_searches", JSON.stringify(recents));

		this.populateRecentSearches();
	}

	getSearchResultsUrl(query) {
		return `/all-products?start=0&search=${encodeURIComponent(query)}`;
	}

	goToSearchResults(query) {
		const target = this.getSearchResultsUrl(query);
		if (window.aracPjaxNavigate) {
			window.aracPjaxNavigate(target);
		} else {
			window.location.href = target;
		}
	}

	populateRecentSearches() {
		let recents = this.getRecentSearches();

		if (!recents.length) {
			this.recents_container.html(`<span class="text-slate-400 text-[11px]">${ __("No searches yet.") }</span>`);
			return;
		}

		let html = "";
		recents.forEach((key) => {
			html += `
				<button type="button" class="recent-search inline-flex items-center gap-1 px-2 py-1 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg text-[11px] font-medium transition-colors cursor-pointer border-none">
					<svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
						<path d="M8.00027 5.20947V8.00017L10 10" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
					${ key }
				</button>
			`;
		});

		this.recents_container.html(html);
		this.attachEventListenersToChips();
	}

	populateResults(product_results) {
		if (!product_results || product_results.length === 0) {
			this.products_container.html("");
			if (this.products_section) this.products_section.addClass("hidden");
			this.updateSectionLayout();
			return;
		}

		let html = "";

		product_results.forEach((res) => {
			let thumbnail = res.thumbnail || res.website_image || '/assets/aracwebshop/images/cart-empty-state.png';
			html += `
				<a href="/${res.route}" class="flex items-center gap-3 p-2 rounded-xl hover:bg-slate-50 transition-colors group text-decoration-none">
					<img class="w-10 h-10 object-contain rounded-lg border border-slate-100 p-1 shrink-0" src="${encodeURI(thumbnail)}" alt="${res.web_item_name}" />
					<div class="flex-1 min-w-0">
						<div class="text-xs font-semibold text-slate-800 group-hover:text-theme-primary truncate transition-colors">${res.web_item_name}</div>
						<div class="text-[10px] text-slate-400 truncate">${res.brand ? "by " + res.brand : (res.item_group || "")}</div>
					</div>
				</a>
			`;
		});

		this.products_container.html(html);
		if (this.products_section) this.products_section.removeClass("hidden");
		this.updateSectionLayout();
	}

	escapeHTML(value) {
		return $("<div>").text(value || "").html();
	}

	escapeAttribute(value) {
		return this.escapeHTML(value).replace(/"/g, "&quot;").replace(/'/g, "&#39;");
	}

	getCategoryHref(category) {
		let route = (category && category.route ? category.route : "").toString().replace(/^\/+/, "");
		return route ? `/${this.escapeAttribute(route)}` : "";
	}

	normalizeCategoryGroups(category_results) {
		if (!Array.isArray(category_results) || !category_results.length) {
			return [];
		}

		let alreadyGrouped = category_results.some((category) => {
			return category && category.parent && Array.isArray(category.children);
		});

		if (!alreadyGrouped) {
			return this.groupCategoriesByParent(category_results);
		}

		return category_results
			.filter((group) => group && group.parent && group.parent.name)
			.map((group) => {
				return {
					parent: group.parent,
					children: Array.isArray(group.children) ? group.children : [],
				};
			});
	}

	groupCategoriesByParent(category_results) {
		let groups = new Map();
		let seenChildren = new Set();

		category_results.forEach((category) => {
			if (!category || !category.name) return;

			let name = category.name.toString();
			let parentName = (category.parent_item_group || "").toString();
			let hasParent = parentName && parentName !== "All Item Groups" && parentName !== name;
			let parentKey = hasParent ? parentName : name;

			if (!groups.has(parentKey)) {
				groups.set(parentKey, {
					parent: {
						name: parentKey,
						route: hasParent ? (category.parent_route || "") : (category.route || ""),
					},
					children: [],
				});
			}

			let group = groups.get(parentKey);
			if (!hasParent) {
				group.parent.route = category.route || group.parent.route;
				return;
			}

			let childKey = `${parentKey}::${name}`;
			if (!seenChildren.has(childKey)) {
				seenChildren.add(childKey);
				group.children.push(category);
			}
		});

		return Array.from(groups.values());
	}

	renderCategoryAction(category, className, html, title) {
		let href = this.getCategoryHref(category);
		let safeTitle = this.escapeAttribute(title || category.name || "");

		if (!href) {
			return `<span class="${className}" title="${safeTitle}">${html}</span>`;
		}

		return `<a href="${href}" class="${className} text-decoration-none" title="${safeTitle}">${html}</a>`;
	}

	renderCategoryGroup(group) {
		let parentName = this.escapeHTML(group.parent.name);
		let children = Array.isArray(group.children) ? group.children : [];
		let childCount = children.length;
		let parentHtml = `
			<span class="search-category-parent-dot" aria-hidden="true"></span>
			<span class="search-category-parent-text">${ parentName }</span>
			${ childCount ? `<span class="search-category-count">${ childCount }</span>` : "" }
		`;
		let childrenHtml = children.map((child) => {
			let childName = this.escapeHTML(child.name);
			return this.renderCategoryAction(
				child,
				"search-category-child",
				`<span class="search-category-child-mark" aria-hidden="true">&rsaquo;</span><span>${ childName }</span>`,
				child.name
			);
		}).join("");
		let childrenSection = childrenHtml
			? `<div class="search-category-children" role="list">${ childrenHtml }</div>`
			: "";

		return `
			<div class="search-category-group">
				${ this.renderCategoryAction(group.parent, "search-category-parent", parentHtml, group.parent.name) }
				${ childrenSection }
			</div>
		`;
	}

	populateCategoriesList(category_results) {
		let categoryGroups = this.normalizeCategoryGroups(category_results);
		if (!categoryGroups.length) {
			this.category_container.html("");
			if (this.category_section) this.category_section.addClass("hidden");
			this.updateSectionLayout();
			return;
		}

		let html = `
			<div class="search-category-heading">
				${ __("Categories") }
			</div>
			<div class="search-category-groups">
				${ categoryGroups.map((group) => this.renderCategoryGroup(group)).join("") }
			</div>
		`;

		this.category_container.html(html);
		if (this.category_section) this.category_section.removeClass("hidden");
		this.updateSectionLayout();
	}
};
